import { Card, Col, Rate, Row, Switch, Tag } from "antd";
import { useState } from 'react'
import { useAuth } from '../../../../store/AuthContext/AuthContext';
import { Column, Area } from '@ant-design/plots';
import { useFetch } from "../../../../hooks/useFetch/useFetch";
import { getColor } from "../../../../common/utils/ColorRate";
import { DownOutlined, DownloadOutlined, InfoCircleOutlined, LoadingOutlined, StarFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import './ReviewsSummary.css';
import '../../../../styles/Summaries.css';
import MathUtils from "../../../../common/utils/MathUtils";
import { SpinLZ } from "../../../components/design/Spinner/SpinLZ";
import PDFGenerator from "../../../components/model/pdf/GeneratePDF";
import { SCHEDULEDJOB } from "../../../../common/constants/services";
import { Synchronized } from "../../../components/design/Synchronized/Synchronized";
import { useHistory, useLocation } from "react-router-dom";
import { BlockReviewsKpis } from "../blocks/BlockReviewsKpis";
import { BlockReviewsGlobal } from "../blocks/BlockReviewsGlobal";
import { BlockReviewsByLocation } from "../blocks/BlockReviewsByLocation";
import SelectPeriod from "../../../components/model/selectMonths/SelectPeriod";
import { PageTitle } from "../../common/PageTitle";
import { PageFilters, PageFilterField } from "../../common/PageFilters";
import { EmptyStateBox } from "../../../components/design/EmptyStateBox/EmptyStateBox";

export const ReviewsSummary = () => {

    const { projectGroup } = useAuth();
    
    const [reviewsKPIs, setReviewsKPIs] = useState<any>(null);
    const [reviewsData, setReviewsData] = useState<any>();
    const [locationInfo, setLocationInfo] = useState<any>();
    const [isLoading, setIsLoading] = useState(true);
    const [selectedType, setSelectedType] = useState('LAST_12MONTHS');
    const [period, setPeriod] = useState<any>();
    const [recentPeriod, setRecentPeriod] = useState<any>();

    const [blockAggregate, setBlockAggregate] = useState<any>();
    const [blockListVisible, setBlockListVisible] = useState<any>();

    const { t } = useTranslation();
    const location = useLocation();
        
    let locationId = new URLSearchParams(location.search).get('locationId');
    locationId = locationId != null ? "?locationId=" + locationId : "";
        
    useFetch(`${process.env.REACT_APP_API}/projects/` + projectGroup.project + '/' + projectGroup.group + '/summary/reviews/locations' + locationId + '?periodOpt=' + selectedType, {}, [],    
        (data: any) => {
            setReviewsKPIs(data.reviewsKPIs);
            setReviewsData(data);
            setIsLoading(false);
            setLocationInfo(data.location);
            setPeriod(data.period);
            setRecentPeriod(data.recentPeriod);
            setBlockAggregate(data.blockAggregate);
            setBlockListVisible(data.blockListVisible);
        });

    const hasReviews = Number(reviewsKPIs?.numberOfReviews) > 0;

    return (
        <div>
            <Card className='main-card-content'>
        
                <Synchronized service={[SCHEDULEDJOB.GBP_REVIEWS]}/>	

                <div style={{display:'flex', color:'slategray', justifyContent:'space-between', alignItems:'center'}}>
                    <PageTitle
                        title='Métricas de Reputación'
                        pageInfo='Analiza la reputación de tus locales: reseñas, puntuación media y evolución en el periodo seleccionado. En esta pantalla podrás también ver la nota media real (es decir sin redondeo), esto permite saber como de cerca estamos de subir la nota media de cada local e incluso cuantas reseñas necesitamos para dar ese salto.'
                        extra={
                            <PageFilters>
                                <PageFilterField label='Periodo'>
                                    <SelectPeriod setSelectedType={setSelectedType} defaultValue={selectedType}/>
                                </PageFilterField>
                            </PageFilters>
                        }
                    />
                </div>        
                
                {isLoading ? <SpinLZ /> : <div className="card-container" style={{ marginTop: 14, padding: '6px 0 0' }}>
                    {!hasReviews ? (
                        <EmptyStateBox
                            title="No hay reseñas en el periodo seleccionado"
                            description="Prueba a ampliar el periodo o selecciona otro rango de fechas."
                            style={{ marginTop: 24 }}
                        />
                    ) : (
                        <>
                            {blockAggregate && reviewsKPIs && (
                                <BlockReviewsKpis
                                    reviewsKPIs={reviewsKPIs}
                                    period={period}
                                    recentPeriod={recentPeriod}
                                    minMax={true}
                                    showRecent={false}
                                />
                            )}
                            {blockAggregate && reviewsData && (
                                <BlockReviewsGlobal
                                    data={reviewsData}
                                    reviewsKPIs={reviewsKPIs}
                                    recentPeriod={recentPeriod}
                                />
                            )}
                            <br/>
                            {blockListVisible && reviewsData && <BlockReviewsByLocation data={reviewsData.locationsKpis} period={period} recentPeriod={recentPeriod} showButtons={true}/>}
                        </>
                    )}
                </div>
                }
            </Card>
        </div>
    )
}